module.exports = __webpack_public_path__ + "website/img/tab1.825f745d.png";